import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { Modal } from 'react-bootstrap';

import Button from 'modules/_shared/components/Buttons';

import { useEditShareModal } from '../context/EditShareModalContext';

const EditShareModalFooter: FC = () => {
  const { t } = useTranslate();

  const { actions } = useEditShareModal();

  return (
    <Modal.Footer>
      <Button onClick={actions.handleSave} text={t('Save')} lgSize />
    </Modal.Footer>
  );
};

export default EditShareModalFooter;
